
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
    meta: {
      title: '商城首页',
      header: false,
      noToken: false
    }
  },
  {
    path: '/topic',
    name: 'topicList',
    component: () => import(/* webpackChunkName: "topic" */'../views/topic/list'),
    meta: {
      title: '专题列表'
    }
  },
  {
    path: '/topic/:id',
    name: 'topicDetail',
    component: () => import(/* webpackChunkName: "topic" */'../views/topic/detail'),
    meta: {
      title: '专题详情'
    }
  },
  {
    path: '/shopcart',
    name: 'shopcart',
    component: () => import(/* webpackChunkName: "cart" */'../views/shopcart'),
    meta: {
      title: '心愿单'
    }
  },
  {
    path: '/goods/:gid',
    name: 'shopGoodsDetail',
    component: () => import(/* webpackChunkName: "goods" */'../views/goods'),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/goods/list/:copid',
    name: 'copGoodslist',
    component: () => import(/* webpackChunkName: "goods" */'../views/goods/list'),
    meta: {
      title: '商品列表'
    }
  },
  {
    path: '/goods/:gid/qrcode',
    name: 'shopGoodsQrcode',
    component: () => import(/* webpackChunkName: "goods" */'../views/goods/qrcode'),
    meta: {
      title: '商品二维码'
    }
  },
  {
    path: '/pay/balance/:gid',
    name: 'pay',
    component: () => import(/* webpackChunkName: "pay" */'../views/pay/index'),
    meta: {
      title: '付款'
    }
  },
  {
    path: '/order/taikang',
    name: 'taikang',
    component: () => import(/* webpackChunkName: "pay" */'../views/pay/taikang'),
    meta: {
      title: '泰康保险'
    }
  },

  {
    path: '/pay/certificate/:oid',
    name: 'Epay',
    component: () => import(/* webpackChunkName: "pay" */'../views/pay/certificate'),
    meta: {
      title: '网银转账'
    }
  },
  {
    path: '/pay/success',
    name: 'paySuccess',
    component: () => import(/* webpackChunkName: "pay" */'../views/pay/success'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/pay/fail',
    name: 'payFail',
    component: () => import(/* webpackChunkName: "pay" */'../views/pay/fail'),
    meta: {
      title: '支付失败'
    }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */'../views/user'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/user/notice',
    name: 'notice',
    component: () => import(/* webpackChunkName: "user" */'../views/user/notice'),
    meta: {
      title: '我的消息'
    }
  },
  {
    path: '/user/address',
    name: 'address',
    component: () => import(/* webpackChunkName: "user" */'../views/user/address/list'),
    meta: {
      title: '收货地址'
    }
  },
  {
    path: '/user/address/add',
    name: 'addAddress',
    component: () => import(/* webpackChunkName: "user" */'../views/user/address/add'),
    meta: {
      title: '新增收货地址'
    }
  },
  {
    path: '/user/address/edit',
    name: 'editAddress',
    component: () => import(/* webpackChunkName: "user" */'../views/user/address/edit'),
    meta: {
      title: '编辑收货地址'
    }
  },
  {
    path: '/user/coupon',
    name: 'coupon',
    component: () => import(/* webpackChunkName: "user" */'../views/user/coupon'),
    meta: {
      title: '优惠券'
    }
  },

  {
    path: '/order',
    name: 'shopOrder',
    component: () => import(/* webpackChunkName: "login" */ '../views/order'),
    meta: {
      title: '订单列表'
    }
  },
  {
    path: '/order/detail/:oid',
    name: 'shopOrderDetail',
    component: () => import(/* webpackChunkName: "login" */ '../views/order/detail'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/order/freight',
    name: 'freight',
    component: () => import(/* webpackChunkName: "order" */'../views/order/freight'),
    meta: {
      title: '运费标准'
    }
  },

  {
    path: '/order/logistics',
    name: 'logistics',
    component: () => import(/* webpackChunkName: "order" */'../views/order/logistics'),
    meta: {
      title: '物流详情'
    }
  },
  {
    path: '/cheapcard',
    name: 'cheapcard',
    component: () => import('../views/user/cheapCard.vue'),
    meta: {
      title: '我的优惠券'
    }
  },
  {
    path: '/selfrun',
    name: 'selfrun',
    component: () => import(/* webpackChunkName: "topic" */'../views/topic/selfrun'),
    meta: {
      title: '胖虎自营'
    }
  },
  {
    path: '/ponhu/about',
    name: 'aboutPonhu',
    component: () => import(/* webpackChunkName: "order" */'../views/ponhu/about'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/airecycle',
    name: 'airecycle',
    component: () => import(/* webpackChunkName: "topic" */'../views/airecycle'),
    meta: {
      title: '胖虎回收'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue'),
    meta: {
      title: '胖虎奢侈品',
      header: false,
      noToken: false
    }
  },
  {
    path: '/publicService',
    name: 'publicService',
    component: () => import('../views/publicService'),
    meta: {
      title: '胖虎公益频道',
      header: false,
      noToken: false
    }
  },
  {
    path: '/newPeople/vip/',
    name: 'vip',
    component: () => import(/* webpackChunkName: "pay" */'../views/newPeople/vip'),
    meta: {
      title: '胖虎新人专享'
    }
  },
  {
    path: '/online/goods/:gid',
    name: 'online_goods',
    component: () => import('../views/online/goods'),
    meta: {
      title: '胖虎奢侈品',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/settlement/:gid',
    name: 'online_order',
    component: () => import('../views/online/settlement'),
    meta: {
      title: '确认订单',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/pay/success',
    name: 'online_order',
    component: () => import('../views/online/success'),
    meta: {
      title: '支付成功',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/pay/fail',
    name: 'online_order',
    component: () => import('../views/online/fail'),
    meta: {
      title: '支付失败',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/blindbox',
    name: 'online_blindbox',
    component: () => import('../views/online/blindbox'),
    meta: {
      title: '胖虎盲盒',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/:price/blindbox',
    name: 'online_blindbox_max',
    component: () => import('../views/online/blind-boxmax'),
    meta: {
      title: '胖虎盲盒',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/purchase/contract/:oid',
    name: 'online_purchase',
    component: () => import('../views/online/purchase/contract'),
    meta: {
      title: '采购签约',
      header: false,
      noToken: true
    }
  },
  {
    path: '/online/purchase/logistics',
    name: 'online_purchase_logistics',
    component: () => import('../views/online/purchase/logistics'),
    meta: {
      title: '上传物流信息',
      header: false,
      noToken: false
    }
  },
  {
    path: '/online/purchase/wallet',
    name: 'online_purchase_wallet',
    component: () => import('../views/online/purchase/wallet'),
    meta: {
      title: '我的钱包',
      header: false,
      noToken: false
    }
  },
  {
    path: '/middle',
    name: 'middle',
    component: () => import('../views/middle'),
    meta: {
      title: ''
    }
  }
]
export default routes
